export default {
  text: '{{threshold}} ventas mensuales: {{amount}}',
  label: '{{threshold}} ventas mensuales:',
  no_discount: 'sin descuento',
  discount_badge: '-{{percentage}}%',
};
